import {makeReactContext} from 'lib/makeReactContext';
import {HandleInfo} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/flowchartIdentifierUtils';

export interface HandlesContextValue {
  connectionDragState: {
    isDragging: boolean;
    sourceHandleInfo?: HandleInfo;
  } | null;
  hideDataFlowEdges: boolean;
}

/** Context to track connection drag state for handle interactions */
export const HandlesContext = makeReactContext<HandlesContextValue>(
  () => ({
    connectionDragState: null,
    hideDataFlowEdges: false,
  }),
  'HandlesContext'
);
